import { Grid } from "@material-ui/core";
import { MasterButton } from "App/Component/ui";
import React from "react";
import { useSelector } from "react-redux";
import { KODE_PRINTER_SETTING } from "utils/all";
import {
  handleClickCetakGelang,
  handleClickCetakLabel,
  handleClickCetakLabelX,
  handleClickCetakManualLabel,
} from "../../utils";
import { defaultPrint } from "./helpers";

function ButtonActionRawatJalan({ formData, registrationId }) {
  const { setting } = useSelector((state) => state);
  const cetakButtonRJ = setting.cetak_button_rj;
  const printerEnv = setting.printer_env;

  const handleClickPrint = () => {
    defaultPrint(
      formData,
      "print-poli",
      registrationId,
      printerEnv,
      KODE_PRINTER_SETTING.printer_antrian_poliklinik
    );
  };

  const handleClickPrintBarcode = () => {
    defaultPrint(
      formData,
      "print-antrian-poliklinik-thermal",
      registrationId,
      printerEnv,
      KODE_PRINTER_SETTING.printer_antrian_poliklinik_thermal
    );
  };

  const handleClickPrintTanpaBarcode = () => {
    defaultPrint(
      formData,
      "print-antrian-poliklinik-dot-matrix",
      registrationId,
      printerEnv,
      KODE_PRINTER_SETTING.printer_antrian_poliklinik_dot_matrix
    );
  };

  return (
    <>
      {parseInt(cetakButtonRJ.label_x) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            color='green'
            name='CETAK LABEL X'
            outline={true}
            size='md'
            onClick={() =>
              handleClickCetakLabelX(
                formData,
                registrationId,
                "print-1x-label-x"
              )
            }
          />
        </Grid>
      )}

      {parseInt(cetakButtonRJ.label_manual) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            color='green'
            name='CETAK LABEL MANUAL'
            outline={true}
            size='md'
            onClick={() =>
              handleClickCetakManualLabel(
                formData,
                registrationId,
                "print-2x-label"
              )
            }
          />
        </Grid>
      )}

      {parseInt(cetakButtonRJ.gelang) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            color='green'
            name='CETAK GELANG'
            outline={true}
            size='md'
            onClick={() =>
              handleClickCetakGelang(formData, printerEnv, registrationId)
            }
          />
        </Grid>
      )}
      {parseInt(cetakButtonRJ.antrian) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            color='green'
            name='CETAK ANTRIAN'
            outline={true}
            size='md'
            onClick={handleClickPrint}
          />
        </Grid>
      )}
      {parseInt(cetakButtonRJ.antrian_barcode) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            color='green'
            name='CETAK ANTRIAN B V2'
            outline={true}
            size='md'
            onClick={handleClickPrintBarcode}
          />
        </Grid>
      )}
      {parseInt(cetakButtonRJ.antrian_tanpa_barcode) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            color='green'
            name='CETAK ANTRIAN TB V2'
            outline={true}
            size='md'
            onClick={handleClickPrintTanpaBarcode}
          />
        </Grid>
      )}

      {parseInt(cetakButtonRJ.label_2x) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            outline={true}
            color={"green"}
            name={"CETAK 2x LABEL"}
            size='md'
            onClick={() =>
              handleClickCetakLabel(formData, registrationId, "print-2x-label")
            }
          />
        </Grid>
      )}

      {parseInt(cetakButtonRJ.label_4x) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            outline={true}
            color={"green"}
            name={"CETAK 4x LABEL"}
            size='md'
            onClick={() =>
              handleClickCetakLabel(formData, registrationId, "print-4x-label")
            }
          />
        </Grid>
      )}

      {parseInt(cetakButtonRJ.label_6x) === 1 && (
        <Grid item>
          <MasterButton
            type='button'
            outline={true}
            color={"green"}
            name={"CETAK 6x LABEL"}
            size='md'
            onClick={() =>
              handleClickCetakLabel(formData, registrationId, "print-6x-label")
            }
          />
        </Grid>
      )}
    </>
  );
}

export default ButtonActionRawatJalan;
